import { ApplicationRouteURL } from './../../shared/config';
import { AuthService } from './../../shared/models/auth.service';
import { Router } from '@angular/router';
import { Component, Input, forwardRef, ViewChildren, QueryList } from '@angular/core';

@Component({
  selector: 'li.menu-Item',
  styles: [`
    .menu-open {
      display: block;
    }
  `],
  template: `
      <template [ngIf]="!data.items">
			<a (click)="GenerateDynamicURL(data.redirectPath)" >
      <i class="{{data.icon}}"></i> <span>{{ data.title | translate }}</span>
      <span class="pull-right-container">
      <i [ngClass]="{'fa fa-angle-left pull-right ': !!data.items && !opened }"></i>
      <i [ngClass]="{'fa fa-angle-down pull-right': !!data.items && opened }"></i>
      </span>
      </a>
      </template>
      <template [ngIf]="data.items">
			<a (click)="onClick($event)">
      <i class="{{data.icon}}"></i> <span>{{data.title | translate }}</span>
      <span class="pull-right-container">
      <i [ngClass]="{'fa fa-angle-left pull-right ': !!data.items && !opened }"></i>
      <i [ngClass]="{'fa fa-angle-down pull-right': !!data.items && opened }"></i>
      </span>
      </a>
      </template>
			<template [ngIf]="!!data.items">
				<ul class="treeview-menu" [ngClass]="{'menu-open': opened}">
  			   <li class="menu-item" cursor:pointer  *ngFor="let menuItem of data.items" [data]="menuItem">
	        </li>
  			</ul>
			</template>
  `,
  //directives: [forwardRef(() => MenuItem), ROUTER_DIRECTIVES]
})
export class MenuItem {
  @Input() data: MenuItem;
  @ViewChildren(MenuItem) children: QueryList<MenuItem>;
  private _opened: boolean = false;
  private _isActive: boolean = false;
  get opened() {
    return this._opened;
  };
  set opened(val) {
    this._opened = val;
    if (!val) {
      this.children.toArray().forEach(x => x.opened = false)
    }
  };
  get isActive() {
    return this._isActive;
  };
  set isActive(val) {
    this._isActive = val;
  };
  constructor(private router: Router
    , private authService: AuthService) {

  }
  onClick(e: any) {
    this.opened = !this.opened;
    this.isActive = !this.isActive;
    if (this.children) {
      e.stopPropagation();
    }
  }

  GenerateDynamicURL(url: string) {
    if (url === 'tripdetailreport') {
      window.location.href = 'https://backoffice.wego.app/';
      return;
    }
    //return url + ";ver=" + Date.now();
    let urlData = this.authService.GetURL(url);
    if (url == ApplicationRouteURL.URL_BOOKING)
      this.router.navigate([urlData, { v: Date.now() }]);
    else
      this.router.navigate([urlData]);
  }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/admin-template/components/menu-item.component.ts